import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Check, AlertCircle } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await api.post("/auth/reset", { token, new_password: password });
      setDone(true);
      setTimeout(() => nav("/login"), 1500);
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    }
    setBusy(false);
  };

  if (!token) {
    return (
      <div className="min-h-screen flex items-center justify-center px-4 bg-[color:var(--cream)]">
        <div className="brutal-card bg-white p-6 max-w-md w-full">
          <AlertCircle size={36} className="mx-auto mb-2 text-[color:var(--coral-deep)]" />
          <h1 className="display text-2xl font-extrabold text-center mb-2">Invalid reset link</h1>
          <p className="text-center text-[color:var(--ink-soft)] mb-4">This link is missing the token.</p>
          <Link to="/forgot-password" className="pill-btn primary w-full justify-center">Request a new one</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[color:var(--cream)]">
      <div className="brutal-card p-8 w-full max-w-md bg-[color:var(--paper)]" data-testid="reset-card">
        <div className="text-center mb-6">
          <div className="text-5xl mb-2" aria-hidden>🔐</div>
          <h1 className="display text-3xl font-extrabold">Pick a new password</h1>
        </div>
        {done ? (
          <div className="brutal-card bg-[#E5F4DD] p-5 text-center" data-testid="reset-done">
            <Check size={36} className="mx-auto mb-2 text-[color:var(--coral)]" />
            <h2 className="display text-xl font-extrabold mb-1">Done — redirecting…</h2>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <label className="block">
              <span className="display font-semibold mb-1 block">New password</span>
              <input className="brutal-input" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="new-password" data-testid="reset-password" />
              <span className="text-xs text-[color:var(--ink-soft)] mt-1 block">Minimum 6 characters.</span>
            </label>
            {error && <div className="brutal-card bg-[#FFE3E0] text-[color:var(--coral-deep)] p-3 text-sm font-bold" data-testid="reset-error">{error}</div>}
            <button type="submit" className="pill-btn primary w-full" disabled={busy || password.length < 6} data-testid="reset-submit">
              {busy ? "Saving…" : "Save new password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
